function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import TextInput from '../../common/controls/textInput';
import Icon from '../../common/containers/icon';
import useLookup from '../../../utils/useLookup';
const JobPhaseCodeItem = props => {
  const {
    onRemove: propsOnRemove,
    onChange: propsOnChange,
    index,
    data,
    data: {
      name: propsDataName
    }
  } = props;
  const pcLabel = useLookup('Phase Code').toLowerCase();
  const onRemove = () => propsOnRemove(index);
  const handleRemove = () => removeItemWithConfirm(data, pcLabel, ['name'], onRemove);
  const handleChange = (name, value) => propsOnChange(index, {
    name,
    value
  });
  const textProps = {
    data,
    onChange: handleChange,
    entity: 'JobPhaseCode',
    focus: true
  };
  const classContainer = `t-jpc-${kebabCase(propsDataName)} t-jpc-${kebabCase(index)}`;
  return /*#__PURE__*/React.createElement("section", {
    className: classContainer
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(TextInput, _objectSpread(_objectSpread({
    field: "name"
  }, textProps), {}, {
    hideLabel: true,
    placeholder: `Enter ${useLookup('Phase Code')} Name`
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: handleRemove,
    className: "form-control t-jpc-remove-phase-code tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " ", `Remove ${useLookup('Phase Code')}`))));
};
JobPhaseCodeItem.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
export default JobPhaseCodeItem;